<template>
  <div class="role-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/role' }">角色管理</el-breadcrumb-item>
      <el-breadcrumb-item>修改角色</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="page-header">
        <div class="page-header-text">
          <span class="page-title">修改角色</span>
          <span class="page-subtitle">调整角色的菜单与操作权限，保存后立即生效；智能助手工具授权请在角色列表「配置助手权限」中设置</span>
        </div>
        <el-button plain size="small" @click="goBack">返回</el-button>
      </div>

      <el-form :model="form" ref="formRef" :rules="formRules" label-width="100px" :inline="false" size="normal">
        <!-- 分区一：基本信息 -->
        <div class="section-title">基本信息</div>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="角色名称：" prop="name">
              <el-input v-model="form.name" placeholder="角色名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="角色描述：" prop="desc">
              <el-input type="textarea" rows="4" v-model="form.desc" placeholder="角色的菜单及权限描述"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 分区二/三：菜单授权 + 操作权限 -->
        <div class="config-row">
          <el-row :gutter="20">
            <el-col :span="7">
              <div class="section-title"><span>菜单授权</span><span class="section-hint">勾选菜单即授予入口，自动联动右侧操作权限</span></div>
              <div class="menu-tree-box">
                <el-tree ref="tree" :data="menus" node-key="_id" :props="defaultProps"
                :show-checkbox="true"
                :check-on-click-node="true"
                :expand-on-click-node="true"
                :default-expand-all="true"
                @check="treeCheckChange">
                </el-tree>
              </div>
            </el-col>
            <el-col :span="17">
              <div class="section-title"><span>操作权限</span><span class="section-hint">勾选操作，含数据范围的模块须成对选择</span></div>
              <div class="rights-box">
                <div v-for="(item,index) in rights" :key="index" class="right-item">
                  <div class="right-item-head">{{item.name}}</div>
                  <el-checkbox-group :key="'group'+item._id" v-model="form.rights[index].actions" @change="checkBoxChange($event,item.name,item._id)">
                    <el-checkbox v-for="(t,i) in item.actions" :label="t" :key="item._id+i">{{t}}</el-checkbox>
                  </el-checkbox-group>
                  <div v-if="item.scopeActions && item.scopeActions.length" class="right-item-scope">
                    <span class="scope-label">数据范围：</span>
                    <el-radio-group :key="'scope'+item._id" v-model="form.rights[index].scopeAction">
                      <el-radio v-for="(t,i) in item.scopeActions" :label="t" :key="'scope_'+item._id+i">{{t}}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 底部操作栏 -->
        <div class="form-actions">
          <el-button type="primary" @click="okClickHandler">修改角色</el-button>
          <el-button @click='goBack'>返回</el-button>
        </div>
      </el-form>

    </el-card>

  </div>
</template>

<script>
import Menu from '../../utility/menu.js'

export default {
  data () {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      menus: null,
      rights: null,

      form: {
        name: '',
        desc: '',
        rights: [],
        menus: []
      },

      formRules: {
        name: { type: 'string', required: true, message: '请输入角色名称', trigger: 'blur' },
        desc: { type: 'string', required: true, message: '请输入角色描述', trigger: 'blur' }
      }

    }
  },

  created () {
    this.getMenusAndRights()
  },

  methods: {
    // 取得菜单和权限
    async getMenusAndRights () {
      const { data: res } = await this.$http.get('role/menusAndRights')
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)

      this.menus = Menu.castMenu(res.data.menus)
      this.rights = res.data.rights
      this.rights.forEach(e => {
        this.form.rights.push({ _id: e._id, moduleCode: e.moduleCode, name: e.name, actions: [], scopeAction: '' })
      })
      this.getInfo()
    },

    // 取得角色详情
    async getInfo () {
      const { data: res } = await this.$http.get(`role/detail/${this.$route.params.id}`)
      if (res.meta.status !== 200) {
        return this.message.error(res.meta.msg)
      }
      this.form.name = res.data.name
      this.form.desc = res.data.desc

      this.setMenusAndRight(res.data.menuIds, res.data.rights)
    },

    /**
     * 根据数据设置菜单和权限
     */
    setMenusAndRight (menus, rights) {
      const keys = []
      for (let i = 0; i < this.menus.length; i++) {
        if (this.menus[i].children && this.menus[i].children.length > 0) {
          for (let j = 0; j < this.menus[i].children.length; j++) {
            if (menus.includes(this.menus[i].children[j]._id)) { keys.push(this.menus[i].children[j]._id) }
          }
        } else {
          if (menus.includes(this.menus[i]._id)) { keys.push(this.menus[i]._id) }
        }
      }
      this.$refs.tree.setCheckedKeys(keys)

      for (let i = 0; i < rights.length; i++) {
        for (let j = 0; j < this.form.rights.length; j++) {
          if (rights[i].moduleCode === this.form.rights[j].moduleCode) {
            this.form.rights[j].actions = [].concat(...rights[i].actions)
            this.form.rights[j].scopeAction = (rights[i].scopeActions || [])[0] || ''
          }
        }
      }
    },

    // 点击树的复选框
    treeCheckChange (data, node) {
      if (node.checkedKeys.includes(data._id)) {
        this.setRightName(data)
      } else {
        this.clearRightName(data)
      }
    },

    setRightName (rightData) {
      // console.log('setRightName')
      if (rightData.children && rightData.children.length) { // 点击主节点
        const children = rightData.children
        for (let i = 0; i < children.length; i++) {
          const rights = this.rights.find(e => {
            return e._id === children[i]._id
          })
          if (rights) {
            this.form.rights.forEach(e => {
              if (e._id === children[i]._id) {
                e.actions = [].concat(...rights.actions)
              }
            })
          }
        }
      } else { // 点击副节点
        const rights = this.rights.find(e => {
          return e._id === rightData._id
        })
        if (!rights) return null
        this.form.rights.forEach(e => {
          if (e._id === rightData._id) {
            e.actions = [].concat(...rights.actions)
          }
        })
      }
    },

    clearRightName (rightData) {
      // console.log('clearRightName')
      if (rightData.children && rightData.children.length) { // 点击主节点
        const children = rightData.children
        for (let i = 0; i < children.length; i++) {
          this.form.rights.forEach(e => {
            if (e._id === children[i]._id) {
              e.actions = []
              e.scopeAction = ''
            }
          })
        }
      } else { // 点击副节点
        this.form.rights.forEach(e => {
          if (e._id === rightData._id) {
            e.actions = []
            e.scopeAction = ''
          }
        })
      }
    },

    checkBoxChange (arr, rightName, id) {
      if (arr.length > 0) {
        this.openMenu(rightName, id)
      } else {
        this.closeMenu(rightName, id)
      }
    },

    openMenu (rightName, id) {
      let menu = null
      for (let i = 0; i < this.menus.length; i++) {
        if (this.menus[i]._id === id) {
          menu = this.menus[i]
          break
        } else if (this.menus[i].children && this.menus[i].children.length > 0) {
          for (let j = 0; j < this.menus[i].children.length; j++) {
            if (this.menus[i].children[j]._id === id) {
              menu = this.menus[i].children[j]
              break
            }
          }
        }
      }

      if (!menu) return null
      const keys = this.$refs.tree.getCheckedKeys()
      keys.push(menu._id)
      this.$refs.tree.setCheckedKeys(keys)
    },

    closeMenu (rightName, id) {
      let menu = null
      for (let i = 0; i < this.menus.length; i++) {
        if (this.menus[i]._id === id) {
          menu = this.menus[i]
          break
        } else if (this.menus[i].children && this.menus[i].children.length > 0) {
          for (let j = 0; j < this.menus[i].children.length; j++) {
            if (this.menus[i].children[j]._id === id) {
              menu = this.menus[i].children[j]
              break
            }
          }
        }
      }

      if (!menu) return null
      const keys = this.$refs.tree.getCheckedKeys(true)
      const arr = keys.filter(e => {
        return e !== menu._id
      })
      this.$refs.tree.setCheckedKeys(arr)
    },

    // 数据范围与操作权限须成对出现：留空即"还没配过"，被默认值填上就分不清是选了还是没管
    scopeSelectionError () {
      const noScope = []
      const noAction = []
      for (let i = 0; i < this.form.rights.length; i++) {
        const item = this.form.rights[i]
        const meta = this.rights.find(e => e._id === item._id)
        const candidates = (meta && meta.scopeActions) || []
        if (!candidates.length) continue
        if (item.actions.length > 0 && !item.scopeAction) {
          noScope.push(item.name)
        } else if (item.actions.length === 0 && item.scopeAction) {
          noAction.push(item.name)
        }
      }
      const tips = []
      if (noScope.length) tips.push(`「${noScope.join('、')}」已选操作权限，请再选择数据范围`)
      if (noAction.length) tips.push(`「${noAction.join('、')}」已选数据范围，请至少勾选一项操作权限`)
      return tips.join('；')
    },

    // 移除空的权限组
    removeEmptyRights () {
      const arr = []
      for (let i = 0; i < this.form.rights.length; i++) {
        if (this.form.rights[i].actions.length > 0) {
          const scopeAction = this.form.rights[i].scopeAction
          arr.push({
            _id: this.form.rights[i]._id,
            actions: [].concat(...this.form.rights[i].actions),
            scopeActions: scopeAction ? [scopeAction] : []
          })
        }
      }
      return arr
    },

    // 点击添加按钮
    async okClickHandler () {
      this.form.menus = this.$refs.tree.getCheckedNodes(false, true).map(e => {
        return e._id
      })
      if (this.form.menus.length < 1) {
        return this.$message.error('请选择菜单')
      }
      const scopeError = this.scopeSelectionError()
      if (scopeError) {
        return this.$message.error(scopeError)
      }
      const rights = this.removeEmptyRights()
      if (rights.length < 1) {
        return this.$message.error('请选择权限')
      }
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return false
        const { data: res } = await this.$http.put(`role/modify/${this.$route.params.id}`, {
          name: this.form.name,
          desc: this.form.desc,
          menus: this.form.menus,
          rights
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success(res.meta.msg)
        this.goBack()
      })
    },

    // 返回
    async goBack () {
      this.$router.push('/role')
    }
  }
}
</script>

<style lang="less" scoped>
/* ===== 页面级设计令牌（--rp-*）：本页视觉唯一来源，调整主题只改这里 ===== */
.role-page {
  --rp-primary: #1976d2;
  --rp-primary-deep: #125ba5;
  --rp-primary-tint: #e8f1fb;
  --rp-ink: #1f2d3d;
  --rp-ink-2: #5e6a78;
  --rp-ink-3: #8a94a6;
  --rp-line: #e6eaf0;
  --rp-line-soft: #f0f2f5;
  --rp-bg-box: #f8fafc;
  --rp-bg-hover: #f3f7fc;
  --rp-radius: 8px;
  --rp-radius-sm: 6px;
  --rp-shadow-card: 0 1px 2px rgba(16, 24, 40, 0.04), 0 6px 20px rgba(16, 24, 40, 0.05);
  --rp-shadow-btn: 0 2px 6px rgba(25, 118, 210, 0.28);
  --rp-transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  /* 卡片容器 */
  .box-card {
    overflow: visible; // 解除全局 overflow:hidden，菜单树 sticky 依赖（滚动容器为 .content）
    border: 1px solid var(--rp-line);
    border-radius: var(--rp-radius);
    box-shadow: var(--rp-shadow-card);
  }

  ::v-deep .el-card__header {
    padding: 14px 24px;
    border-bottom: 1px solid var(--rp-line-soft);
  }

  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .page-header-text {
    display: flex;
    align-items: baseline;
    gap: 12px;
    flex-wrap: wrap;
  }

  .page-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--rp-ink);
    letter-spacing: 0.3px;
  }

  .page-subtitle {
    font-size: 12px;
    color: var(--rp-ink-3);
  }

  /* 分区标题：主色渐变竖条 + 标题 + 弱化提示 */
  .section-title {
    display: flex;
    align-items: baseline;
    margin: 24px 0 12px;
    font-size: 14px;
    font-weight: 600;
    color: var(--rp-ink);

    &::before {
      content: '';
      align-self: center;
      width: 3px;
      height: 14px;
      margin-right: 8px;
      background: linear-gradient(180deg, var(--rp-primary), var(--rp-primary-deep));
      border-radius: 2px;
    }
  }

  .section-hint {
    margin-left: 10px;
    font-size: 12px;
    font-weight: 400;
    color: var(--rp-ink-3);
  }

  /* 布局：左右列 flex 等高，菜单树 sticky 依赖（默认 el-row block+float 不等高） */
  .config-row {
    margin-top: 8px;

    .el-row {
      display: flex;
    }
  }

  /* 盒容器（菜单树 / 操作权限 / 智能助手表格共用视觉语言） */
  .menu-tree-box {
    position: sticky;
    top: 12px;
    border: 1px solid var(--rp-line);
    border-radius: var(--rp-radius);
    max-height: 480px;
    overflow: auto;
    padding: 12px;
    background: var(--rp-bg-box);
  }

  .rights-box {
    border: 1px solid var(--rp-line);
    border-radius: var(--rp-radius);
    padding: 4px 20px;
    background: var(--rp-bg-box);
  }

  .right-item {
    padding: 14px 12px;
    margin: 0 -12px;
    border-bottom: 1px solid var(--rp-line-soft);
    border-radius: var(--rp-radius-sm);
    transition: var(--rp-transition);

    &:hover {
      background: var(--rp-bg-hover);
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .right-item-head {
    margin-bottom: 8px;
    font-weight: 600;
    color: var(--rp-ink);
  }

  .right-item .el-checkbox-group {
    line-height: 22px;
  }

  .right-item .el-checkbox {
    margin-right: 20px;
  }

  .right-item-scope {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 8px;
  }

  .scope-label {
    margin-right: 8px;
    font-size: 12px;
    color: var(--rp-ink-3);
  }

  /* 底部操作栏与按钮层级：主按钮唯一强调，返回为次要 */
  .form-actions {
    margin-top: 16px;
    padding-top: 24px;
    border-top: 1px solid var(--rp-line);
    text-align: right;
  }

  ::v-deep .el-button {
    border-radius: var(--rp-radius-sm);
  }

  ::v-deep .el-button--primary {
    box-shadow: var(--rp-shadow-btn);
  }

  ::v-deep .el-input__inner,
  ::v-deep .el-textarea__inner {
    border-radius: var(--rp-radius-sm);
  }
}
</style>
